import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Button.scss';
var propTypes = {
  /**
   * Function triggered on button's click event.
   */
  onClick: PropTypes.func.isRequired,

  /**
   * Children content of the button.
   */
  children: PropTypes.node.isRequired,

  /**
   * CSS Class of the button.
   */
  className: PropTypes.string.isRequired,

  /**
   * Title of the button.
   */
  title: PropTypes.string.isRequired
};
/**
 * This component displays a simple button.
 */

var Button =
/*@__PURE__*/
function (PureComponent) {
  function Button() {
    PureComponent.apply(this, arguments);
  }

  if (PureComponent) Button.__proto__ = PureComponent;
  Button.prototype = Object.create(PureComponent && PureComponent.prototype);
  Button.prototype.constructor = Button;

  Button.prototype.render = function render() {
    var ref = this.props;
    var _onClick = ref.onClick;
    var children = ref.children;
    var className = ref.className;
    var title = ref.title;
    return React.createElement('div', {
      className: "tm-button " + className,
      role: "button",
      tabIndex: "0",
      title: title,
      'aria-label': title,
      onKeyPress: function onKeyPress(e) {
        return e.which === 13 && _onClick();
      },
      onClick: function onClick() {
        return _onClick();
      }
    }, children);
  };

  return Button;
}(PureComponent);

Button.propTypes = propTypes;
export default Button;